







import {Component, Vue, Prop} from 'vue-property-decorator'
import NotLoggedPanel from '@/components/NotLoggedPanel.vue';
import TimeEntriesList from '@/components/TimeEntriesList.vue';
import { User } from '@/models/user';

@Component({
    name: 'TimeEntries',
    components: {
        TimeEntriesList,
        NotLoggedPanel
    }
})
export default class TimeEntries extends Vue{
    @Prop() private user!: User;
}
